import React, { PropTypes } from 'react';
import { trIn } from '../utils';
import Slider from 'react-slick';
import ArticleText from './ArticleText';
import Immutable from 'immutable';
import PrevBtn from './PrevBtn';
import NextBtn from './NextBtn';

const getImages = (item) => item.has('images') && item.get('images').first();
const getFirstImage = (item) => getImages(item).get('data', Immutable.fromJS([{}])).first();

const Image = ({ lang, item, position }) => (
  <div className={position}>
    {position === 'bottom' && <ArticleText item={item} lang={lang} />}
    {item.has('images') &&
      <div className="bloc-image">
        <img
          className={position}
          src={getFirstImage(item).get('url')}
          alt={trIn(getFirstImage(item), 'label', lang)}
        />
      </div>}
    {position === 'bottom' || <ArticleText item={item} lang={lang} />}
  </div>
);

Image.propTypes = {
  item: PropTypes.object.isRequired,
  lang: PropTypes.string.isRequired,
  position: PropTypes.string.isRequired,
};

const Slide = ({ item, lang, className, style }) => (
  <div className={`${className} itemcarrousel`} style={style}>
    <img
      src={item.get('url')}
      alt={trIn(item, 'label', lang)}
    />
    {item.has('texte') && item.get('texte') !== '' && <div>{item.get('texte')}</div>}
  </div>
);

Slide.propTypes = {
  item: PropTypes.object.isRequired,
  style: PropTypes.object,
  lang: PropTypes.string.isRequired,
  className: PropTypes.string,
};

const Carousel = ({ lang, item, position }) => {
  const settings = {
    infinite: true,
    arrows: true,
    dots: false,
    useCSS: true,
    nextArrow: new NextBtn(),
    prevArrow: new PrevBtn(),
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  return (
    <div className={`carrousel-${position}`}>
      <ArticleText item={item} lang={lang} />
      <div className="containercarrousel">
        <Slider {...settings}>
          {getImages(item).get('data', new Immutable.List()).map((data, i) =>
            <Slide key={i} item={data} lang={lang} />)}
        </Slider>
      </div>
      <div className="clearboth" />
    </div>
  );
};

Carousel.propTypes = {
  item: PropTypes.object.isRequired,
  lang: PropTypes.string.isRequired,
  position: PropTypes.string.isRequired,
};


const Images = ({ item, lang, position, carousel }) =>
  React.createElement(carousel ? Carousel : Image, {
    lang,
    position,
    item,
    // : carousel ? item.get('images').first() : item.get('images').first().get('data').first(),
  }
);

Images.propTypes = {
  item: PropTypes.object.isRequired,
  lang: PropTypes.string.isRequired,
  position: PropTypes.string.isRequired,
  carousel: PropTypes.bool.isRequired,
};

export default Images;



// WEBPACK FOOTER //
// ./common/components/Images.js